import { REACT_QUERY_KEYS } from '@hungryroot/rest';

export const GET_CUSTOMER_ORDERS_QUERY_KEY = [
  REACT_QUERY_KEYS.CUSTOMER_ORDERS,
  'v2',
];
export const GET_CUSTOMER_ORDERS_QUERY_KEY_PAST = 'Past Orders';
export const GET_CUSTOMER_ORDERS_QUERY_KEY_CURRENT = 'Current Orders';
export const GET_CUSTOMER_ORDERS_QUERY_KEY_UPCOMING = 'Upcoming Orders';
